import scrollMonitor from "scrollmonitor";
import Accordion from "accordion-js";
import { animate, scroll } from "motion";

export default class SP_Product_Filter {
    constructor() {
        this.page = {
            current: "",
            name: "",
            term_id: null,
            term_ids: [],
            litur_ids: ["null"],
            description: null,
            posts_displayed: 0,
            posts_page: 1,
            posts_total: 0,
            cats: {},
            loading: false,
            init: false,
            updated: false,
        };
        this.filter = {
            original_height: 0,
            closed_height: 56,
        };
        $ = jQuery;

        this.init();
    }
    init() {
        this.set_categories(this);
        this.scrolling(this);
        this.click_functions(this);
        this.submit_functions(this);
        this.set_page_info(this);

        this.accordion();
        this.filter_wrap_init();
        // this.page.init = true;
    }

    set_categories(instance) {
        let cats_list = $(".ob-filter-category .ob-filter-option");

        $.each(cats_list, function (i, el) {
            instance.page.cats[$(el).data("slug")] = $(el).data("termId");
        });
    }
    set_page_info(instance, page_slug) {
        const { current, url, title_array } = this.get_page_info();
        const { init, cats, name } = this.page;
        const page_current = !page_slug ? current : page_slug;
        const term_id = String(cats[page_current]);

        this.page.current = page_current;
        this.page.term_id = term_id;

        if (!init) {
            this.page.term_ids = [term_id];
            this.set_filter_option(this);
            this.filter_update_handler_init(term_id, page_current, null);

            setTimeout(() => window.scrollTo(0, 0), 300);
        }

        const base_url = url.origin;
        const new_url =
            page_current === "vorur"
                ? `${base_url}/${page_current}`
                : `${base_url}/voruflokkur/${page_current}`;

        if (name) {
            document.title = [`${name} `, ...title_array].join("|");
        }

        history.pushState({}, "", new_url);
    }
    get_page_info() {
        const url = new URL(location);
        let page_object = {
            url: url,
        };
        let pathnames = url.pathname.split("/").filter((item) => item !== "");
        let doc_title_arr = document.title.split("|").filter((item) => item !== "");
        doc_title_arr.shift();

        if (pathnames.length <= 2) {
            page_object.current = pathnames[pathnames.length - 1];
        } else {
            throw Error("Sub category error");
        }

        page_object.title_array = doc_title_arr;

        return page_object;
    }
    submit_functions(instance) {
        $(".ob-filter-search form").on("submit", function (e) {
            e.preventDefault();

            const form_data = $(this).find("input").val();

            SP_Product_Filter.start_loading();
            instance.filter_search_handler(form_data);
        });
    }
    click_functions(instance) {
        const cat_filter_option = $(".ob-filter-option");
        const cat_filter_title = $(".ob-filter-title");
        let clicked = false;

        cat_filter_option.on("click", function (e) {
            e.preventDefault();

            if (clicked) return;
            const $target = $(e.target);
            let option_name, option_slug, option_term_id;
            let litur_option_name, litur_option_slug, litur_term_id;

            SP_Product_Filter.start_loading();

            const has_litur_class = $target.hasClass("ob-litur-option");
            if (has_litur_class) {
                ({
                    liturName: litur_option_name,
                    liturSlug: litur_option_slug,
                    liturTermId: litur_term_id,
                } = this.dataset);

                ({
                    name: option_name,
                    current: option_slug,
                    term_id: option_term_id,
                } = instance.page);
            } else {
                ({ name: option_name, slug: option_slug, termId: option_term_id } = this.dataset);
            }

            if ($target.hasClass("ob-filter-option-all")) {
                $(".ob-filter-option").removeClass("ob-selected");
            }

            if (option_term_id) {
                $(".ob-filter-option-all").removeClass("ob-selected");
            } else {
                $(".ob-filter-option").removeClass("ob-selected");
            }

            // Toggle selection class and determine if the option is selected
            $target.toggleClass("ob-selected");

            const selected = $target.hasClass("ob-selected");

            // Trigger filtering and loading
            instance.filter_get_options(
                instance,
                option_name,
                option_term_id ?? null,
                option_slug ?? null,
                litur_term_id ?? null,
                selected
            );
            // instance.page.name = option_name ?? null;

            clicked = true;
            // Reset the `clicked` flag after a delay
            setTimeout(() => {
                clicked = false;
            }, 300);
        });

        cat_filter_title.on("click", function (e) {
            e.preventDefault();

            if (clicked || !SP_Product_Filter.responsive_mode()) return;
            clicked = true;
            let filter_height = $(".ob-filter-wrap").height();
            let filter_items = $(this).parent(".ob-filter-items");

            filter_items.toggleClass(".ob-filter-open");
            let animate_height = !filter_items.hasClass(".ob-filter-open")
                ? instance.filter.closed_height
                : instance.filter.original_height;
            animate(
                ".ob-filter-wrap",
                { height: animate_height },
                { duration: 2, ease: [0.16, 1, 0.3, 1] }
            );

            setTimeout(() => (clicked = false), 300);
        });
    }
    static start_loading() {
        $(".ob-product-wrap").addClass("ob-products-dummy-active");
        // $(".ob-filter-loader").addClass("ob-active");
    }
    static end_loading() {
        $(".ob-product-wrap").removeClass("ob-products-dummy-active");
        // $(".ob-filter-loader").removeClass("ob-active");
    }
    filter_get_options(instance, option_name, option_term_id, option_slug, option_litur, selected) {
        instance.page.name = option_name;

        if (selected) {
            // Add the term_id
            if (option_litur) {
                instance.page.litur_ids.push(option_litur);
            } else {
                instance.page.term_ids.push(option_term_id);
                instance.page.term_id = option_term_id;
            }
        } else {
            if (option_litur) {
                instance.page.litur_ids = instance.page.litur_ids.filter(
                    (key) => key !== option_litur
                );
            } else {
                instance.page.term_ids = instance.page.term_ids.filter(
                    (key) => key !== option_term_id
                );
            }
        }

        if (option_term_id == "null") instance.page.term_ids = ["null"];
        if (option_litur == "null") instance.page.litur_ids = ["null"];

        instance.filter_update_handler_init(
            instance.page.term_ids,
            option_slug,
            instance.page.litur_ids
        );
    }
    filter_update_handler_init(option_term_id, option_name, option_litur_ids) {
        let filter_update_call = SP_Product_Filter.product_filter_update(
            option_term_id,
            option_name,
            option_litur_ids
        );

        filter_update_call.then((res) => {
            this.page.init = true;
            // this.page.loading = true;
            this.page.posts_displayed = res.post_count;
            this.page.posts_total = res.found_posts;
            this.page.loading = !(this.page.posts_displayed === this.page.posts_total);
            // this.page.posts_page++;

            this.products_html_init(res);
            console.log(this);

            // window.scrollTo(0, 0);

            setTimeout(() => {
                SP_Product_Filter.end_loading();
                this.page.posts_page = 2;
                this.set_page_info(this, option_name);
            }, 600);
        });
    }
    static async product_filter_update(term_id, term_name, option_litur, next_page = 1) {
        const request_body = {
            security: ajax_object.product_filter_update_nonce,
            action: "get_filter_products_action",
            data: [term_id, term_name, option_litur, next_page],
        };
        const request = {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Cache-Control": "no-cache",
            },
            body: jQuery.param(request_body),
        };

        try {
            const respose = await fetch(ajax_object.ajax_url, request);
            const response_json = await respose.json();

            console.log(response_json);

            if (response_json.success) {
                return response_json;
            } else {
                throw new Error("products return response unsuccessful");
            }
        } catch (err) {
            console.error(err);
        }
    }
    scrolling(instance) {
        var products_wrap = document.querySelector(".ob-product-wrap");
        var products_wrap_watcher = scrollMonitor.create(products_wrap);

        products_wrap_watcher.on("stateChange", function () {
            let loading_point = products_wrap_watcher.height / 2;

            if (instance.page.loading) {
                if (!instance.page.updated && $(window).scrollTop() > loading_point) {
                    instance.filter_update_hander_load(
                        instance.page.term_id,
                        instance.page.current,
                        instance.page.posts_page
                    );
                    instance.page.updated = true;
                } else if ($(window).scrollTop() <= loading_point) {
                    // console.log("Above the loading point.");
                }
            }
        });
    }
    filter_update_hander_load(option_term_id, option_name, next_page) {
        let filter_update_call = SP_Product_Filter.product_filter_update(
            option_term_id,
            option_name,
            null,
            next_page
        );

        filter_update_call.then((res) => {
            // this.page.init = true;
            // this.page.loading = true;
            this.page.posts_displayed = this.page.posts_displayed + res.post_count;
            // this.page.posts_total = res.found_posts;
            this.page.loading = !(this.page.posts_displayed === this.page.posts_total);
            this.page.posts_page++;

            this.products_html_load(res);
            // this.set_page_info(this, option_name);
            this.page.updated = false;

            // window.scrollTo(0, 0);

            console.log(this.page);
        });
    }
    products_html_init(response) {
        const products = response.data;
        // console.log(this)
        $(".ob-product-wrap .ob-products").remove();
        $(".ob-product-wrap .ob-filter-search-title").remove();
        // $(".ob-product-wrap .ob-products-display-text").remove();
        $("<div>", { class: "ob-products" }).appendTo(".ob-product-wrap");
        // $("<div>", { class: "ob-products-display-text" }).appendTo(".ob-product-wrap");
        $(".ob-product-wrap .ob-products").append(...products);

        let post_display_text = `Sýnir ${response.found_posts} vörur`;
        $(".ob-product-filter .ob-filter-products-display-text").text(post_display_text);
    }
    products_html_load(response) {
        const products = response.data;

        $(".ob-product-wrap .ob-products").append(...products);

        let post_display_text = `Sýnir ${response.found_posts} vörur`;
        $(".ob-product-filter .ob-filter-products-display-text").text(post_display_text);
    }
    set_filter_option(instance) {
        let filter_ops = $(".ob-filter-option");
        $(".ob-filter-option").removeClass("ob-selected");

        $.each(filter_ops, function (i, el) {
            if ($(el).data("slug") == instance.page.current) {
                $(el).toggleClass("ob-selected");
            }
        });

        // $(".ob-filter-option .ob-check").removeClass("ob-selected");
        // checkbox;
    }
    filter_search_handler(search_query) {
        let filter_search_query = SP_Product_Filter.product_filter_search_update(search_query);

        filter_search_query.then((res) => {
            // this.page.init = true;
            // this.page.loading = true;
            this.page.posts_displayed = res.post_count;
            this.page.posts_total = res.found_posts;
            this.page.loading = !(this.page.posts_displayed === this.page.posts_total);
            // this.page.posts_page++;

            this.products_search_html_init(res);
            console.log(this);

            // window.scrollTo(0, 0);

            setTimeout(() => {
                SP_Product_Filter.end_loading();
                this.page.posts_page = 2;
                // this.set_page_info(this, option_name);
            }, 600);
        });
    }
    static async product_filter_search_update(search_q, next_page = 1) {
        const search_query = search_q.toString();
        const request_body = {
            security: ajax_object.product_filter_search_nonce,
            action: "get_filter_search_action",
            data: [search_query, next_page],
        };
        const request = {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Cache-Control": "no-cache",
            },
            body: jQuery.param(request_body),
        };

        try {
            const respose = await fetch(ajax_object.ajax_url, request);
            const response_json = await respose.json();

            console.log(response_json);

            if (response_json.success) {
                return response_json;
            } else {
                throw new Error("products return response unsuccessful");
            }
        } catch (err) {
            console.error(err);
        }
    }
    products_search_html_init(response) {
        const products = response.data;
        // console.log(this)
        $(".ob-product-wrap .ob-products").remove();
        $(".ob-product-wrap .ob-filter-search-title").remove();
        // $(".ob-product-wrap .ob-products-display-text").remove();
        $("<div>", { class: "ob-products" }).appendTo(".ob-product-wrap");
        // $("<div>", { class: "ob-products-display-text" }).appendTo(".ob-product-wrap");
        $(".ob-product-wrap .ob-products").append(...products);

        let post_display_text = `Sýnir ${response.found_posts} vörur`;
        $(".ob-product-filter .ob-filter-products-display-text").text(post_display_text);

        $(".ob-product-wrap").prepend(
            `<div class="ob-filter-search-title"><h3>Leitar að: ${response.search_query}</h3></div>`
        );
    }
    accordion() {
        let accordion = jQuery(".accordion-container");
        if (accordion.length) {
            let accordions_open = SP_Product_Filter.responsive_mode() ? [0] : [0, 1];
            let accordions_multi = !SP_Product_Filter.responsive_mode();
            SP_Product_Filter.accordion = new Accordion(".accordion-container", {
                showMultiple: accordions_multi,
                openOnInit: accordions_open,
            });
        }
    }
    filter_wrap_init() {
        if (!SP_Product_Filter.responsive_mode()) return;

        this.filter.original_height = $(".ob-filter-wrap").height() + 16;

        $(".ob-filter-wrap").height(this.filter.closed_height);

        scroll(
            (e) => {
                if (e) {
                    $(".ob-product-filter-wrap").addClass("ob-filter-sticky");
                } else {
                    $(".ob-product-filter-wrap").removeClass("ob-filter-sticky");
                }
            },
            { target: document.querySelector(".ob-product-filter-wrap") }
        );
    }
    static responsive_mode() {
        return window.innerWidth <= 770 ? true : false;
    }
}
